var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.user
    ? _c(
        "div",
        { staticClass: "integrations-view row" },
        [
          _c("b-card-group", { attrs: { deck: "" } }, [
            _c(
              "div",
              {
                staticClass:
                  "col-6 d-flex flex-wrap justify-content-center mt-3",
              },
              [
                _c(
                  "b-card",
                  {
                    staticClass: "white-card account-card",
                    attrs: { title: "API" },
                  },
                  [
                    _c(_setup.ApiKeyInput, {
                      attrs: { "allow-regenerate": !_setup.user?.User_Id },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "col-6 d-flex flex-wrap justify-content-center mt-3",
              },
              [
                _c(
                  "b-card",
                  {
                    staticClass: "white-card account-card",
                    attrs: { title: "remove.bg API" },
                  },
                  [
                    _c(
                      "b-form",
                      {
                        on: {
                          submit: function ($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            return _setup.onRemoveBgSubmit()
                          },
                        },
                      },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              id: "remove-bg-input",
                              label: "API Key",
                              "label-for": "remove-bg-input",
                            },
                          },
                          [
                            _c(
                              "b-input-group",
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    id: "remove-bg-input",
                                    type: _setup.showFields.removeBg
                                      ? "text"
                                      : "password",
                                  },
                                  model: {
                                    value: _setup.removeBgApiKey,
                                    callback: function ($$v) {
                                      _setup.removeBgApiKey = $$v
                                    },
                                    expression: "removeBgApiKey",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "b-input-group-append",
                                  [
                                    _c(
                                      "b-btn",
                                      {
                                        attrs: { variant: "link" },
                                        on: {
                                          click: function ($event) {
                                            _setup.showFields.removeBg = !_setup
                                              .showFields.removeBg
                                          },
                                        },
                                      },
                                      [
                                        _c("font-awesome-icon", {
                                          attrs: {
                                            icon: _setup.showFields.removeBg
                                              ? ["far", "eye-slash"]
                                              : ["far", "eye"],
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("b-form-text", { staticClass: "link" }, [
                              _vm._v(
                                "\n                            API Key to use remove.bg services with Customily. Get it\n                            "
                              ),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: "https://www.remove.bg/api",
                                    target: "_blank",
                                  },
                                },
                                [_vm._v("here")]
                              ),
                              _vm._v(".\n                        "),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c(_setup.CCheckbox, {
                              attrs: {
                                label: "Use Customily as fallback",
                                switch: "",
                                disabled: _setup.savingState.removeBgFallback,
                              },
                              on: { input: _setup.onRemoveBgFallbackChange },
                              model: {
                                value: _setup.removeBgFallback,
                                callback: function ($$v) {
                                  _setup.removeBgFallback = $$v
                                },
                                expression: "removeBgFallback",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "small",
                              { staticClass: "form-text text-muted" },
                              [
                                _vm._v(
                                  "\n                            If your API credits run out or the service becomes unavailable, Customily will\n                            automatically take over to prevent your customers from being blocked.\n                        "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "d-flex justify-content-end" },
                          [
                            _c(
                              "b-btn",
                              {
                                attrs: { variant: "outline-primary" },
                                on: {
                                  click: function ($event) {
                                    return _setup.openRateLimitModal(
                                      "RemoveBg",
                                      "remove.bg"
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                            Set Rate Limit\n                        "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              _setup.LoaderBtn,
                              {
                                staticClass: "ml-3",
                                attrs: {
                                  type: "submit",
                                  variant: "primary",
                                  loading: _setup.savingState.removeBg,
                                  disabled: !_setup.modifiedRemoveBgApiKey,
                                  "loading-text": "Saving",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                            Save\n                        "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "col-6 d-flex justify-content-center align-self-start mt-3",
              },
              [
                _c(
                  "b-card",
                  {
                    staticClass: "white-card account-card",
                    attrs: { title: "OpenAI API" },
                  },
                  [
                    _c(
                      "b-form",
                      {
                        on: {
                          submit: function ($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            return _setup.onOpenAiSubmit()
                          },
                        },
                      },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              id: "openAi-input",
                              label: "API Key",
                              "label-for": "openAi-input",
                            },
                          },
                          [
                            _c(
                              "b-input-group",
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    id: "openAi-input",
                                    state: _setup.openAiApiKeyState,
                                    "aria-describedby":
                                      "openAi-input-help openAi-input-feedback",
                                    trim: "",
                                    type: _setup.showFields.openAi
                                      ? "text"
                                      : "password",
                                  },
                                  model: {
                                    value: _setup.openAiApiKey,
                                    callback: function ($$v) {
                                      _setup.openAiApiKey = $$v
                                    },
                                    expression: "openAiApiKey",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "b-input-group-append",
                                  [
                                    _c(
                                      "b-btn",
                                      {
                                        attrs: { variant: "link" },
                                        on: {
                                          click: function ($event) {
                                            _setup.showFields.openAi = !_setup
                                              .showFields.openAi
                                          },
                                        },
                                      },
                                      [
                                        _c("font-awesome-icon", {
                                          attrs: {
                                            icon: _setup.showFields.openAi
                                              ? ["far", "eye-slash"]
                                              : ["far", "eye"],
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-text",
                              { attrs: { "text-variant": "danger" } },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_setup.openAiError) +
                                    "\n                        "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("b-form-text", { staticClass: "link" }, [
                              _vm._v(
                                "\n                            API Key to use OpenAI services with Customily. Get it\n                            "
                              ),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      "https://platform.openai.com/api-keys",
                                    target: "_blank",
                                  },
                                },
                                [_vm._v("here")]
                              ),
                              _vm._v(".\n                        "),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "d-flex justify-content-end" },
                          [
                            _c(
                              "b-btn",
                              {
                                attrs: { variant: "outline-primary" },
                                on: {
                                  click: function ($event) {
                                    return _setup.openRateLimitModal(
                                      "OpenAi",
                                      "OpenAI"
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                            Set Rate Limit\n                        "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              _setup.LoaderBtn,
                              {
                                staticClass: "ml-3",
                                attrs: {
                                  type: "submit",
                                  disabled: !_setup.openAiVerified,
                                  variant: "primary",
                                  loading: _setup.savingState.openAi,
                                },
                              },
                              [
                                _vm._v(
                                  "\n                            Save\n                        "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-6 d-flex justify-content-center mt-3" },
              [
                _c(
                  "b-card",
                  {
                    staticClass: "white-card account-card",
                    attrs: { title: "Spotify API Credentials" },
                  },
                  [
                    _c(
                      "b-form",
                      {
                        on: {
                          submit: function ($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            return _setup.onSpotifyCredentialsSubmit()
                          },
                        },
                      },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              id: "spotify-client-id",
                              label: "Client ID",
                              "label-for": "spotify-client-id-input",
                            },
                          },
                          [
                            _c(
                              "b-input-group",
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    id: "spotify-client-id-input",
                                    type: _setup.showFields.spotifyClientId
                                      ? "text"
                                      : "password",
                                  },
                                  model: {
                                    value: _setup.spotifyClientID,
                                    callback: function ($$v) {
                                      _setup.spotifyClientID = $$v
                                    },
                                    expression: "spotifyClientID",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "b-input-group-append",
                                  [
                                    _c(
                                      "b-btn",
                                      {
                                        attrs: { variant: "link" },
                                        on: {
                                          click: function ($event) {
                                            _setup.showFields.spotifyClientId = !_setup
                                              .showFields.spotifyClientId
                                          },
                                        },
                                      },
                                      [
                                        _c("font-awesome-icon", {
                                          attrs: {
                                            icon: _setup.showFields
                                              .spotifyClientId
                                              ? ["far", "eye-slash"]
                                              : ["far", "eye"],
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              id: "spotify-client-secret",
                              label: "Client Secret",
                              "label-for": "spotify-client-secret-input",
                            },
                          },
                          [
                            _c(
                              "b-input-group",
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    id: "spotify-client-secret-input",
                                    type: _setup.showFields.spotifyClientSecret
                                      ? "text"
                                      : "password",
                                  },
                                  model: {
                                    value: _setup.spotifyClientSecret,
                                    callback: function ($$v) {
                                      _setup.spotifyClientSecret = $$v
                                    },
                                    expression: "spotifyClientSecret",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "b-input-group-append",
                                  [
                                    _c(
                                      "b-btn",
                                      {
                                        attrs: { variant: "link" },
                                        on: {
                                          click: function ($event) {
                                            _setup.showFields.spotifyClientSecret = !_setup
                                              .showFields.spotifyClientSecret
                                          },
                                        },
                                      },
                                      [
                                        _c("font-awesome-icon", {
                                          attrs: {
                                            icon: _setup.showFields
                                              .spotifyClientSecret
                                              ? ["far", "eye-slash"]
                                              : ["far", "eye"],
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          _setup.LoaderBtn,
                          {
                            staticClass: "float-right ml-3",
                            attrs: {
                              type: "submit",
                              variant: "primary",
                              loading: _setup.savingState.spotifyCredentials,
                              "loading-text": "Saving",
                            },
                          },
                          [
                            _vm._v(
                              "\n                        Save\n                    "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "col-6 d-flex flex-wrap justify-content-center mt-3",
              },
              [
                _c(
                  "b-card",
                  {
                    staticClass: "white-card account-card",
                    attrs: { title: "Cutout.pro API" },
                  },
                  [
                    _c(
                      "b-form",
                      {
                        on: {
                          submit: function ($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            return _setup.onCutoutProSubmit()
                          },
                        },
                      },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              id: "cutout-pro-input",
                              label: "API Key",
                              "label-for": "cutout-pro-input",
                            },
                          },
                          [
                            _c(
                              "b-input-group",
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    id: "cutout-pro-input",
                                    type: _setup.showFields.cutoutPro
                                      ? "text"
                                      : "password",
                                  },
                                  model: {
                                    value: _setup.cutoutProApiKey,
                                    callback: function ($$v) {
                                      _setup.cutoutProApiKey = $$v
                                    },
                                    expression: "cutoutProApiKey",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "b-input-group-append",
                                  [
                                    _c(
                                      "b-btn",
                                      {
                                        attrs: { variant: "link" },
                                        on: {
                                          click: function ($event) {
                                            _setup.showFields.cutoutPro = !_setup
                                              .showFields.cutoutPro
                                          },
                                        },
                                      },
                                      [
                                        _c("font-awesome-icon", {
                                          attrs: {
                                            icon: _setup.showFields.cutoutPro
                                              ? ["far", "eye-slash"]
                                              : ["far", "eye"],
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-text",
                              { attrs: { "text-variant": "danger" } },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_setup.cutoutProError) +
                                    "\n                        "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("b-form-text", { staticClass: "link" }, [
                              _vm._v(
                                "\n                            API Key to use cutout.pro services with Customily. Get it\n                            "
                              ),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: "https://www.cutout.pro/api",
                                    target: "_blank",
                                  },
                                },
                                [_vm._v("here")]
                              ),
                              _vm._v(".\n                        "),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c(_setup.CCheckbox, {
                              attrs: {
                                label: "Use Customily as fallback",
                                switch: "",
                                disabled: _setup.savingState.cutoutProFallback,
                              },
                              on: { input: _setup.onCutoutProFallbackChange },
                              model: {
                                value: _setup.cutoutProFallback,
                                callback: function ($$v) {
                                  _setup.cutoutProFallback = $$v
                                },
                                expression: "cutoutProFallback",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "small",
                              { staticClass: "form-text text-muted" },
                              [
                                _vm._v(
                                  "\n                            If your API credits run out or the service becomes unavailable, Customily will\n                            automatically take over to prevent your customers from being blocked.\n                        "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "d-flex justify-content-end" },
                          [
                            _c(
                              "b-btn",
                              {
                                attrs: { variant: "outline-primary" },
                                on: {
                                  click: function ($event) {
                                    return _setup.openRateLimitModal(
                                      "CutoutPro",
                                      "Cutout.pro"
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                            Set Rate Limit\n                        "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              _setup.LoaderBtn,
                              {
                                staticClass: "ml-3",
                                attrs: {
                                  type: "submit",
                                  variant: "primary",
                                  loading: _setup.savingState.cutoutPro,
                                  disabled: !_setup.modifiedCutoutProApiKey,
                                  "loading-text": "Saving",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                            Save\n                        "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-6 d-flex justify-content-center mt-3" },
              [
                _c(
                  "b-card",
                  {
                    staticClass: "white-card account-card",
                    attrs: { title: "Wilcom embroidery credentials" },
                  },
                  [
                    _c(
                      "b-form",
                      {
                        on: {
                          submit: function ($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            return _setup.onWilcomCredentialsSubmit()
                          },
                        },
                      },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              id: "wilcom-app-id",
                              label: "App ID",
                              "label-for": "wilcom-app-id-input",
                            },
                          },
                          [
                            _c(
                              "b-input-group",
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    id: "wilcom-app-id-input",
                                    type: _setup.showFields.wilcomAppId
                                      ? "text"
                                      : "password",
                                  },
                                  model: {
                                    value: _setup.wilcomAppId,
                                    callback: function ($$v) {
                                      _setup.wilcomAppId = $$v
                                    },
                                    expression: "wilcomAppId",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "b-input-group-append",
                                  [
                                    _c(
                                      "b-btn",
                                      {
                                        attrs: { variant: "link" },
                                        on: {
                                          click: function ($event) {
                                            _setup.showFields.wilcomAppId = !_setup
                                              .showFields.wilcomAppId
                                          },
                                        },
                                      },
                                      [
                                        _c("font-awesome-icon", {
                                          attrs: {
                                            icon: _setup.showFields.wilcomAppId
                                              ? ["far", "eye-slash"]
                                              : ["far", "eye"],
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              id: "wilcom-app-key",
                              label: "App Key",
                              "label-for": "wilcom-app-key-input",
                            },
                          },
                          [
                            _c(
                              "b-input-group",
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    id: "wilcom-app-key-input",
                                    type: _setup.showFields.wilcomAppKey
                                      ? "text"
                                      : "password",
                                  },
                                  model: {
                                    value: _setup.wilcomAppKey,
                                    callback: function ($$v) {
                                      _setup.wilcomAppKey = $$v
                                    },
                                    expression: "wilcomAppKey",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "b-input-group-append",
                                  [
                                    _c(
                                      "b-btn",
                                      {
                                        attrs: { variant: "link" },
                                        on: {
                                          click: function ($event) {
                                            _setup.showFields.wilcomAppKey = !_setup
                                              .showFields.wilcomAppKey
                                          },
                                        },
                                      },
                                      [
                                        _c("font-awesome-icon", {
                                          attrs: {
                                            icon: _setup.showFields.wilcomAppKey
                                              ? ["far", "eye-slash"]
                                              : ["far", "eye"],
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          _setup.LoaderBtn,
                          {
                            staticClass: "float-right ml-4",
                            attrs: {
                              type: "submit",
                              variant: "primary",
                              loading: _setup.savingState.wilcomCredentials,
                              "loading-text": "Saving",
                            },
                          },
                          [
                            _vm._v(
                              "\n                        Save\n                    "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-6 d-flex justify-content-center mt-3" },
              [
                _c(
                  "b-card",
                  {
                    staticClass: "white-card account-card",
                    attrs: { title: "Melco embroidery credentials" },
                  },
                  [
                    _c(
                      "b-form",
                      {
                        on: {
                          submit: function ($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            return _setup.onMelcoCredentialsSubmit()
                          },
                        },
                      },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              id: "melco-username",
                              label: "Melco Username",
                              "label-for": "melco-username-input",
                            },
                          },
                          [
                            _c(
                              "b-input-group",
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    id: "melco-username-input",
                                    type: _setup.showFields.melcoUsername
                                      ? "text"
                                      : "password",
                                  },
                                  model: {
                                    value: _setup.melcoUsername,
                                    callback: function ($$v) {
                                      _setup.melcoUsername = $$v
                                    },
                                    expression: "melcoUsername",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "b-input-group-append",
                                  [
                                    _c(
                                      "b-btn",
                                      {
                                        attrs: { variant: "link" },
                                        on: {
                                          click: function ($event) {
                                            _setup.showFields.melcoUsername = !_setup
                                              .showFields.melcoUsername
                                          },
                                        },
                                      },
                                      [
                                        _c("font-awesome-icon", {
                                          attrs: {
                                            icon: _setup.showFields
                                              .melcoUsername
                                              ? ["far", "eye-slash"]
                                              : ["far", "eye"],
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              id: "melco-api-key",
                              label: "Melco Api Key",
                              "label-for": "melco-api-key-input",
                            },
                          },
                          [
                            _c(
                              "b-input-group",
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    id: "melco-api-key-input",
                                    type: _setup.showFields.melcoApiKey
                                      ? "text"
                                      : "password",
                                  },
                                  model: {
                                    value: _setup.melcoApiKey,
                                    callback: function ($$v) {
                                      _setup.melcoApiKey = $$v
                                    },
                                    expression: "melcoApiKey",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "b-input-group-append",
                                  [
                                    _c(
                                      "b-btn",
                                      {
                                        attrs: { variant: "link" },
                                        on: {
                                          click: function ($event) {
                                            _setup.showFields.melcoApiKey = !_setup
                                              .showFields.melcoApiKey
                                          },
                                        },
                                      },
                                      [
                                        _c("font-awesome-icon", {
                                          attrs: {
                                            icon: _setup.showFields.melcoApiKey
                                              ? ["far", "eye-slash"]
                                              : ["far", "eye"],
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          _setup.LoaderBtn,
                          {
                            staticClass: "float-right ml-3",
                            attrs: {
                              type: "submit",
                              variant: "primary",
                              loading: _setup.savingState.melcoCredentials,
                              "loading-text": "Saving",
                            },
                          },
                          [
                            _vm._v(
                              "\n                        Save\n                    "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _setup.user?.CanvaAccessToken?.length
              ? _c(
                  "div",
                  {
                    staticClass:
                      "col-6 d-flex justify-content-center mt-3 h-fit-content",
                  },
                  [
                    _c("div", { staticClass: "card white-card account-card" }, [
                      _c(
                        "div",
                        { staticClass: "card-body" },
                        [
                          _c("h4", { staticClass: "card-title" }, [
                            _vm._v("Canva API"),
                          ]),
                          _vm._v(" "),
                          _c(
                            _setup.LoaderBtn,
                            {
                              staticClass: "float-right ml-4",
                              attrs: {
                                type: "submit",
                                variant: "danger",
                                "loading-text": "Diconnecting",
                                loading: _setup.savingState.canvaCredentials,
                              },
                              on: { click: _setup.diconnectUserFromCanva },
                            },
                            [
                              _vm._v(
                                "\n                        Disconnect\n                    "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _setup.isImageEffectsEnabled
              ? _c(
                  "div",
                  {
                    staticClass:
                      "col-6 d-flex flex-wrap justify-content-center mt-3",
                  },
                  [
                    _c(
                      "b-card",
                      {
                        staticClass: "white-card account-card",
                        attrs: { title: "Google Gemini API" },
                      },
                      [
                        _c(
                          "b-form",
                          {
                            on: {
                              submit: function ($event) {
                                $event.stopPropagation()
                                $event.preventDefault()
                                return _setup.onGoogleGeminiApiSubmit()
                              },
                            },
                          },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  id: "gemini-api-input",
                                  label: "API Key",
                                  "label-for": "gemini-api-input",
                                },
                              },
                              [
                                _c(
                                  "b-input-group",
                                  [
                                    _c("b-form-input", {
                                      attrs: {
                                        id: "gemini-api-input",
                                        type: _setup.showFields.googleGemini
                                          ? "text"
                                          : "password",
                                      },
                                      model: {
                                        value: _setup.googleGeminiApiKey,
                                        callback: function ($$v) {
                                          _setup.googleGeminiApiKey = $$v
                                        },
                                        expression: "googleGeminiApiKey",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "b-input-group-append",
                                      [
                                        _c(
                                          "b-btn",
                                          {
                                            attrs: { variant: "link" },
                                            on: {
                                              click: function ($event) {
                                                _setup.showFields.googleGemini = !_setup
                                                  .showFields.googleGemini
                                              },
                                            },
                                          },
                                          [
                                            _c("font-awesome-icon", {
                                              attrs: {
                                                icon: _setup.showFields
                                                  .googleGemini
                                                  ? ["far", "eye-slash"]
                                                  : ["far", "eye"],
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-text",
                                  { attrs: { "text-variant": "danger" } },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(_setup.googleGeminiError) +
                                        "\n                        "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("b-form-text", { staticClass: "link" }, [
                                  _vm._v(
                                    "\n                            API Key to use Google Gemini services with Customily. Get it\n                            "
                                  ),
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href:
                                          "https://aistudio.google.com/apikey",
                                        target: "_blank",
                                      },
                                    },
                                    [_vm._v("here")]
                                  ),
                                  _vm._v(".\n                        "),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "d-flex justify-content-end" },
                              [
                                _c(
                                  "b-btn",
                                  {
                                    attrs: { variant: "outline-primary" },
                                    on: {
                                      click: function ($event) {
                                        return _setup.openRateLimitModal(
                                          "GoogleGemini",
                                          "Google Gemini"
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            Set Rate Limit\n                        "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  _setup.LoaderBtn,
                                  {
                                    staticClass: "ml-3",
                                    attrs: {
                                      type: "submit",
                                      variant: "primary",
                                      loading: _setup.savingState.googleGemini,
                                      "loading-text": "Saving",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            Save\n                        "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _setup.isImageEffectsEnabled
              ? _c(
                  "div",
                  {
                    staticClass:
                      "col-6 d-flex flex-wrap justify-content-center mt-3",
                  },
                  [
                    _c(
                      "b-card",
                      {
                        staticClass: "white-card account-card",
                        attrs: { title: "OpenRouter API" },
                      },
                      [
                        _c(
                          "b-form",
                          {
                            on: {
                              submit: function ($event) {
                                $event.stopPropagation()
                                $event.preventDefault()
                                return _setup.onOpenRouterApiSubmit()
                              },
                            },
                          },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  id: "open-router-input",
                                  label: "API Key",
                                  "label-for": "open-router-input",
                                },
                              },
                              [
                                _c(
                                  "b-input-group",
                                  [
                                    _c("b-form-input", {
                                      attrs: {
                                        id: "open-router-input",
                                        type: _setup.showFields.openRouter
                                          ? "text"
                                          : "password",
                                      },
                                      model: {
                                        value: _setup.openRouterApiKey,
                                        callback: function ($$v) {
                                          _setup.openRouterApiKey = $$v
                                        },
                                        expression: "openRouterApiKey",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "b-input-group-append",
                                      [
                                        _c(
                                          "b-btn",
                                          {
                                            attrs: { variant: "link" },
                                            on: {
                                              click: function ($event) {
                                                _setup.showFields.openRouter = !_setup
                                                  .showFields.openRouter
                                              },
                                            },
                                          },
                                          [
                                            _c("font-awesome-icon", {
                                              attrs: {
                                                icon: _setup.showFields
                                                  .openRouter
                                                  ? ["far", "eye-slash"]
                                                  : ["far", "eye"],
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-text",
                                  { attrs: { "text-variant": "danger" } },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(_setup.openRouterError) +
                                        "\n                        "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("b-form-text", { staticClass: "link" }, [
                                  _vm._v(
                                    "\n                            API Key to use OpenRouter services with Customily. Get it\n                            "
                                  ),
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href:
                                          "https://openrouter.ai/settings/keys",
                                        target: "_blank",
                                      },
                                    },
                                    [_vm._v("here")]
                                  ),
                                  _vm._v(".\n                        "),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "d-flex justify-content-end" },
                              [
                                _c(
                                  "b-btn",
                                  {
                                    attrs: { variant: "outline-primary" },
                                    on: {
                                      click: function ($event) {
                                        return _setup.openRateLimitModal(
                                          "OpenRouter",
                                          "OpenRouter"
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            Set Rate Limit\n                        "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  _setup.LoaderBtn,
                                  {
                                    staticClass: "ml-4",
                                    attrs: {
                                      type: "submit",
                                      variant: "primary",
                                      loading: _setup.savingState.openRouter,
                                      "loading-text": "Saving",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            Save\n                        "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _setup.isImageEffectsEnabled
              ? _c(
                  "div",
                  {
                    staticClass:
                      "col-6 d-flex flex-wrap justify-content-center mt-3",
                  },
                  [
                    _c(
                      "b-card",
                      {
                        staticClass: "white-card account-card",
                        attrs: { title: "PicWish API" },
                      },
                      [
                        _c(
                          "b-form",
                          {
                            on: {
                              submit: function ($event) {
                                $event.stopPropagation()
                                $event.preventDefault()
                                return _setup.onPicWishApiSubmit()
                              },
                            },
                          },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  id: "picwish-input",
                                  label: "API Key",
                                  "label-for": "picwish-input",
                                },
                              },
                              [
                                _c(
                                  "b-input-group",
                                  [
                                    _c("b-form-input", {
                                      attrs: {
                                        id: "picwish-input",
                                        type: _setup.showFields.picWish
                                          ? "text"
                                          : "password",
                                      },
                                      model: {
                                        value: _setup.picWishApiKey,
                                        callback: function ($$v) {
                                          _setup.picWishApiKey = $$v
                                        },
                                        expression: "picWishApiKey",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "b-input-group-append",
                                      [
                                        _c(
                                          "b-btn",
                                          {
                                            attrs: { variant: "link" },
                                            on: {
                                              click: function ($event) {
                                                _setup.showFields.picWish = !_setup
                                                  .showFields.picWish
                                              },
                                            },
                                          },
                                          [
                                            _c("font-awesome-icon", {
                                              attrs: {
                                                icon: _setup.showFields.picWish
                                                  ? ["far", "eye-slash"]
                                                  : ["far", "eye"],
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-text",
                                  { attrs: { "text-variant": "danger" } },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(_setup.picWishError) +
                                        "\n                        "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("b-form-text", { staticClass: "link" }, [
                                  _vm._v(
                                    "\n                            API Key to use PicWish services with Customily. Get it\n                            "
                                  ),
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href:
                                          "https://picwish.com/my-account?subRoute=api-key",
                                        target: "_blank",
                                      },
                                    },
                                    [_vm._v("here")]
                                  ),
                                  _vm._v(".\n                        "),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "d-flex justify-content-end" },
                              [
                                _c(
                                  "b-btn",
                                  {
                                    attrs: { variant: "outline-primary" },
                                    on: {
                                      click: function ($event) {
                                        return _setup.openRateLimitModal(
                                          "Picwish",
                                          "PicWish"
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            Set Rate Limit\n                        "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  _setup.LoaderBtn,
                                  {
                                    staticClass: "ml-3",
                                    attrs: {
                                      type: "submit",
                                      variant: "primary",
                                      loading: _setup.savingState.picWish,
                                      "loading-text": "Saving",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            Save\n                        "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(_setup.ApiRateLimitModal, {
            attrs: {
              provider: _setup.activeRateLimit.provider,
              "provider-label": _setup.activeRateLimit.label,
              "attempts-per-ip": _setup.activeRateLimit.attemptsPerIp,
              "retry-after-minutes": _setup.activeRateLimit.retryAfterMinutes,
            },
            on: { saved: _setup.onRateLimitSaved },
            model: {
              value: _setup.showRateLimitModal,
              callback: function ($$v) {
                _setup.showRateLimitModal = $$v
              },
              expression: "showRateLimitModal",
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }